<template>
  <div class="content home-page terms-page">
    <div class="terms-page-inner">
      <div class="terms-header">
        <button class="terms-back" @click="back">
          <img src="../../static/images/back.png" alt="back">
        </button>
        <div class="terms-title">{{$t('TC')}}</div>
        <div class="terms-header-placeholder"></div>
      </div>

      <div class="terms-card" v-if="list !== ''">
        <div class="terms-card-content" v-html="list"></div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  data() {
    return {
      list: ''
    }
  },
  created() {
    this.getHome()
  },
  methods: {
    back() {
      this.$router.go(-1)
    },
    getHome() {
      let that = this
      let data = {
        type: '2'
      }
      that.$api.post('/api/index/help', data, r => {
        that.$parent.returnCode(r, function () {
          if (localStorage.getItem('lang') == 'en') {
            that.list = r.data.content
          } else {
            that.list = r.data.mm_content
          }
          that.$parent.loadModal(false)
        })
      })
    }
  }
}
</script>
<style scoped>
.terms-page {
  min-height: 100vh;
  padding-top: 0 !important;
  padding-bottom: 0 !important;
  background: #080126 url('../../static/images/livequiz/main_bg.jpg') no-repeat center center fixed;
  background-size: cover;
}

.terms-page-inner {
  min-height: 100vh;
  padding: 86px 32px 48px;
  box-sizing: border-box;
}

.terms-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
}

.terms-back {
  width: 72px;
  height: 72px;
  padding: 0;
  border: 0;
  background: transparent;
  box-shadow: none;
}

.terms-back img {
  display: block;
  width: 100%;
}

.terms-header-placeholder {
  width: 72px;
  height: 72px;
  flex-shrink: 0;
}

.terms-title {
  flex: 1;
  text-align: center;
  font-size: 60px;
  line-height: 1;
  font-weight: 700;
  color: #ffffff;
  text-shadow:
    -2px -2px 0 rgba(231, 88, 124, 0.95),
    2px -2px 0 rgba(231, 88, 124, 0.95),
    -2px 2px 0 rgba(231, 88, 124, 0.95),
    2px 2px 0 rgba(231, 88, 124, 0.95);
}

.terms-card {
  margin-top: 42px;
  height: calc(100vh - 248px);
  padding: 34px 28px;
  border-radius: 30px;
  background: rgba(255, 255, 255, 0.94);
  box-sizing: border-box;
  box-shadow: 0 18px 40px rgba(73, 30, 20, 0.14);
}

.terms-card-content {
  height: 100%;
  overflow-y: auto;
  padding-right: 10px;
  font-size: 22px;
  line-height: 1.7;
  color: #222222;
  word-break: break-word;
}

.terms-card-content::-webkit-scrollbar {
  width: 8px;
}

.terms-card-content::-webkit-scrollbar-thumb {
  border-radius: 8px;
  background: #f6a121;
}

.terms-card-content::-webkit-scrollbar-track {
  background: transparent;
}

.terms-card-content :deep(h1),
.terms-card-content :deep(h2),
.terms-card-content :deep(h3),
.terms-card-content :deep(h4),
.terms-card-content :deep(strong) {
  color: #111111;
  font-weight: 700;
}

.terms-card-content :deep(p) {
  margin: 0 0 20px;
}

.terms-card-content :deep(ul),
.terms-card-content :deep(ol) {
  margin: 0 0 20px;
  padding-left: 28px;
}

.terms-card-content :deep(li) {
  margin-bottom: 12px;
}
</style>



// WEBPACK FOOTER //
// src/page/termsAndCondition.vue